var React = require('react');

function V02 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval"),React.createElement("g",{"id":"4.-20210908-小企業","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"/202106-event","transform":"translate(-115.000000, -1545.000000)","fill":"#4328CA"},React.createElement("circle",{"id":"Oval","cx":"129.5","cy":"1559.5","r":"14.5"})))]);
}

V02.defaultProps = {"width":"29px","height":"29px","viewBox":"0 0 29 29","version":"1.1"};

module.exports = V02;

V02.default = V02;
